import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const readwise = defineConnector({
  identifier: "readwise",
  name: "Readwise",
  tagLine: "Highlights from books and articles",
  keywords: "highlights books articles reading notes kindle annotations",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://readwise\\.io/api/v2/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.accessToken,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Get your access token",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to Readwise, open the [access token page](https://readwise.io/access_token), and copy your access token.",
        },
      ],
    },
    {
      title: "Paste your access token",
      items: [
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://readwise.io/api/v2/auth/",
      expectedStatus: 204,
    }),
  },
});
